webpackJsonp([41],{

/***/ "EUWj":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(true);
// imports


// module
exports.push([module.i, "@-webkit-keyframes pulse{0%{-webkit-transform:scale(1);transform:scale(1);opacity:.6}50%{-webkit-transform:scale(1.0125);transform:scale(1.0125);opacity:.3}to{-webkit-transform:scale(1.025);transform:scale(1.025);opacity:0}}@keyframes pulse{0%{-webkit-transform:scale(1);transform:scale(1);opacity:.6}50%{-webkit-transform:scale(1.0125);transform:scale(1.0125);opacity:.3}to{-webkit-transform:scale(1.025);transform:scale(1.025);opacity:0}}.page-daily-markets-details{background:#fff;padding:10px 15px 0}.page-daily-markets-details__headline{text-align:center}.page-daily-markets-details__emp{font-size:18px;font-weight:700}", "", {"version":3,"sources":["/home/vsts/work/1/s/src/components/pages/page-daily-markets-details/page-daily-markets-details.scss"],"names":[],"mappings":"AACA,yBACA,GACI,2BAA4B,AACpB,mBAAoB,AAC5B,UAAa,CAChB,AACD,IACI,gCAAiC,AACzB,wBAAyB,AACjC,UAAa,CAChB,AACD,GACI,+BAAgC,AACxB,uBAAwB,AAChC,SAAW,CACd,CACA,AACD,iBACA,GACI,2BAA4B,AACpB,mBAAoB,AAC5B,UAAa,CAChB,AACD,IACI,gCAAiC,AACzB,wBAAyB,AACjC,UAAa,CAChB,AACD,GACI,+BAAgC,AACxB,uBAAwB,AAChC,SAAW,CACd,CACA,AAQD,4BACE,gBAAiB,AACjB,mBAAqB,CACtB,AACD,sCACI,iBAAmB,CACtB,AACD,iCACI,eAAgB,AAChB,eAAkB,CACrB","file":"page-daily-markets-details.scss","sourcesContent":["/* stylelint-disable at-rule-no-unknown */\n@-webkit-keyframes pulse {\n0% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n    opacity: 0.6;\n}\n50% {\n    -webkit-transform: scale(1.0125);\n            transform: scale(1.0125);\n    opacity: 0.3;\n}\n100% {\n    -webkit-transform: scale(1.025);\n            transform: scale(1.025);\n    opacity: 0;\n}\n}\n@keyframes pulse {\n0% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n    opacity: 0.6;\n}\n50% {\n    -webkit-transform: scale(1.0125);\n            transform: scale(1.0125);\n    opacity: 0.3;\n}\n100% {\n    -webkit-transform: scale(1.025);\n            transform: scale(1.025);\n    opacity: 0;\n}\n}\n\n/**\n * Foundation for Sites\n * Version 6.6.3\n * https://get.foundation\n * Licensed under MIT Open Source\n */\n.page-daily-markets-details {\n  background: #fff;\n  padding: 10px 15px 0;\n}\n.page-daily-markets-details__headline {\n    text-align: center;\n}\n.page-daily-markets-details__emp {\n    font-size: 18px;\n    font-weight: bold;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ "KfAn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_cmsContent__ = __webpack_require__("tQfv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_seoMeta__ = __webpack_require__("08z+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__daily_pages_constants__ = __webpack_require__("9MVc");







/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_cmsContent__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_seoMeta__["a" /* default */]],
  props: {
    pageId: {
      type: String,
      required: true
    }
  },
  metaInfo: function metaInfo() {
    var _this = this;

    var info = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(__WEBPACK_IMPORTED_MODULE_5__daily_pages_constants__["a" /* DAILY_PAGES */]);
    var pageData = info.find(function (i) {
      return i.pageId === _this.pageId;
    });

    return this.buildSeoMeta({
      title: (pageData || {}).title || 'Daily Markets'
    });
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('browse', ['getStaticPageFull'])),
  created: function created() {
    var _this2 = this;

    this.getStaticPageFull(this.pageId).then(function (data) {
      _this2.installDynamicControls({ data: data });
    });
  }
});

/***/ }),

/***/ "UhjY":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("EUWj");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("0746c0e8", content, true, {});

/***/ }),

/***/ "WTcQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-daily-markets-details",domProps:{"innerHTML":_vm._s(_vm.content)}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Ykf8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_page_daily_markets_details_js__ = __webpack_require__("KfAn");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b6aedb5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_daily_markets_details_vue__ = __webpack_require__("WTcQ");
function injectStyle (ssrContext) {
  __webpack_require__("UhjY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_page_daily_markets_details_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b6aedb5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_daily_markets_details_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ })

});


// WEBPACK FOOTER //
// static/js/41.d3b6ef5ee72c5231d618.js